import Main from "../components/sections/contact/Main";

function Contact() {
  return (
    <Main/>
  );
}
export default Contact;
